import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./back-to.module.scss"
import Button from "../../atoms/button"

const BackTo = ({ name, url }) => {
  const { backTo } = useStaticQuery(graphql`
    {
      backTo: sanityDictionary(key: { current: { eq: "back_to" } }) {
        value
      }
    }
  `)
  return (
    <div className={styles.back}>
      <Button variant="secondary" url={url}>
        {backTo?.value} {name}
      </Button>
    </div>
  )
}

export default BackTo

BackTo.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
}
